<template>
    <div class="question-wrap">
        <div class="question">
            Would you like to share your report when it's ready?
        </div>
        <div class="com">
            <div class="input-wrap">
                <input
                type="text"
                class="input"
                placeholder="Name"
                name="name"
                v-model="report_name"
                />
            </div>
            <div class="input-wrap">
                <input
                type="text"
                class="input toLowerCase"
                placeholder="Email"
                name="email"
                v-validate="'required|email'"
                :class="{ invalid: errors.has('email') }"
                v-model="email"
                />
                <span class="validate-error" v-if="errors.has('email')">
                  <template>
                      {{errors.first("email")}} 
                  </template>
                </span>
            </div>
            <div class="input-wrap">
                <textarea
                id="comment"
                placeholder="Comment"
                name="comment"
                v-model="comment"
                ></textarea>
            </div>
      </div>
      <button class="btn" @click.prevent="$validator.validateAll()" @click="sendData" :disabled="!isValidEmail">Continue</button>
      <button class="back-btn" @click="skipData">Skip</button>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  import apiV2 from "../../api";

  export default {
    name: "ShareReport",
    data() {
      return {
        email: null,
        comment: null,
        report_name: null
      };
    },
    computed: {
      ...mapGetters(["userInfo"]),
      isValidEmail() {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(this.email);
      }
    },
    methods: {
      sendData() {
        if (this.email !== null) {
          this.email = this.email.toLocaleLowerCase();
        }
        if (this.comment !== null) {
          this.comment = this.comment.toLocaleLowerCase();
        }
        const data = {
          kit_id: this.userInfo.kit_id,
          report_forward_email: this.email,
          report_comment: this.comment,
          report_name: this.report_name,
          status: null
        };
        apiV2.post("/v2/kits/share-report", data).then(res => {
          this.$emit("nextStep", 1);
        });
      },
      skipData() {
        this.$emit("nextStep", 1);
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  @import "../../../styles/colors";
    #comment{
    height: 110px;
    padding: 15px 20px;
    color: $gray;
    width: 100%;
    margin-bottom: 5px;
    font-size: 16px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    font-family: TTNormsMedium, sans-serif;
    outline: none;
}
  .btn:disabled {
    cursor: default;
    opacity: 0.5;
  }
  .checkbox-items-wrap {
    display: flex;
    justify-content: center;
  }
  .label-checkbox {
    display: flex;
    align-items: center;
    position: relative;
  }
  .checkbox {
    opacity: 0;
    width: 100%;
    margin: 0;
    height: 100%;
    z-index: 1;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
  }
  .checkbox-wrap {
    position: relative;
    width: 72px;
    height: 24px;
  }
  
  .checkbox-toggle-text {
    position: absolute;
    z-index: 2;
    color: $white;
    font-size: 11px;
    text-transform: uppercase;
    font-family: TTNormsMedium, sans-serif;
    top: 9px;
    left: 15px;
    cursor: pointer;
  }
  .checkbox-toggle-text-right {
    left: auto;
    right: 15px;
  }
  .slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    width: 100%;
    height: 100%;
    border-radius: 20px;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 28px;
    width: 28px;
    left: 0;
    bottom: -2px;
    box-shadow: 0 0 2px 1px $boxShadow;
    background-color: $white;
    transition: 0.4s;
    border-radius: 100%;
  }
  .checkbox:checked + .slider {
    background-color: $green;
  }
  
  .checkbox:checked + .slider:before {
    transform: translateX(44px);
  }
  .title {
    color: #005eb8;
    font-size: 27px;
    margin: 0 0 30px 0;
    text-align: center;
    font-family: TTNormsBold, sans-serif;
  }
  .subtitle {
    text-align: center;
    font-size: 16px;
    font-family: TTNormsRegular, sans-serif;
    width: 100%;
    margin: 0 auto 20px auto;
    line-height: 1.3;
  }
  .text-bottom {
    text-align: center;
    font-size: 14px;
    margin-top: 36px;
    font-family: TTNormsRegular, sans-serif;
    line-height: 18px;
  }
  .terms-link {
    color: $blue;
    font-size: 14px;
    line-height: 18px;
    font-family: TTNormsRegular, sans-serif;
    cursor: pointer;
  }
  .question {
    font-size: 16px;
    font-family: TTNormsMedium, sans-serif;
    text-align: center;
    margin: 0 0px 15px 0;
  }
  .btn {
    background-color: $green;
    width: 50%;
    margin: 36px auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $white;
    cursor: pointer;
    outline: none;
    border: none;
    height: 45px;
    border-radius: 25px;
    max-width: 300px;
    transition: all 0.5s linear;
    font-size: 18px;
    font-family: TTNormsBold, sans-serif;
  }
  .back-btn {
    color: $green;
    border: none;
    cursor: pointer;
    outline: none;
    display: block;
    margin: 36px auto 0 auto;
    background-color: transparent;
    font-size: 16px;
    font-family: TTNormsMedium, sans-serif;
  }
  .input {
  padding: 15px 20px;
  color: $gray;
  width: 100%;
  margin-bottom: 5px;
  font-size: 16px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #cccccc;
  font-family: TTNormsMedium, sans-serif;
  outline: none;
}

.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-transform: capitalize;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input-wrap {
  margin: 0 0 20px;
}

.input.invalid {
  border: 1px solid $red;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 26px auto 0 auto;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
  </style>
  